import { CreateMessageRequest } from '@wtax/data-angular';
import { CreateMessagePayload } from '../interfaces/create-message-payload.interface';

export const mapCreateMessagePayload = (message: CreateMessagePayload): CreateMessageRequest => ({
  body: message.body,
  attachment_ids: message.attachmentIds,
});
